import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import ProtectedRoute from 'components/common/ProtectedRoute';
import DefaultView from 'components/common/DefaultView';
import ProtectedProjectRoute from 'components/common/ProtectedProjectRoute';
import ProtectedDataRepoRoute from 'components/common/ProtectedDataRepoRoute';


const Main = lazy(() => import('components/views/main/Main'));
const Login = lazy(() => import('components/views/login/Login'));
const ReleaseNotes = lazy(() =>
  import('components/views/main/releaseNotes/ReleaseNotes')
);
const ProjectRepository = lazy(() =>
  import('components/views/main/projects/ProjectRepository')
);
const DataRepository = lazy(() =>
  import('components/views/main/data/DataRepositoryMain/DataRepository')
);
const Users = lazy(() => import('components/views/main/data/UsersTable/UsersTable'));
const Feedback = lazy(() => import('components/views/main/data/UsersFeedbackTable/UsersFeedbackTable'));
export const ROUTE_PATHS = {
  DEFAULT: '/',
  HOME: '/dashboard',
  PROJECT: '/projectRepository',
  RELEASE_NOTES: '/release-notes',
  DATA: '/dataRepository',
  USERS: '/users',
  FEEDBACK: '/feedback',
};
//TODO: Add ProtectedDataRepoRoute back when permissions are set up
const routes = [
  {
    path: ROUTE_PATHS.HOME,
    element: (
      <ProtectedRoute>
        <DefaultView>
          <Main />
        </DefaultView>
      </ProtectedRoute>
    ),
  },
  {
    path: ROUTE_PATHS.PROJECT,
    element: (
      <ProtectedRoute>
        <ProtectedProjectRoute>
          <DefaultView>
            <ProjectRepository />
          </DefaultView>
        </ProtectedProjectRoute>
      </ProtectedRoute>
    ),
  },
  {
    path: ROUTE_PATHS.DATA,
    element: (
      <ProtectedRoute>
        {/* <ProtectedDataRepoRoute> */}
          <DefaultView>
            <DataRepository />
          </DefaultView>
        {/* </ProtectedDataRepoRoute> */}
      </ProtectedRoute>
    ),
  },
  {
    path: ROUTE_PATHS.RELEASE_NOTES,
    element: (
      <ProtectedRoute>
        {/* <ProtectedDataRepoRoute> */}
          <DefaultView>
            <ReleaseNotes />
          </DefaultView>
        {/* </ProtectedDataRepoRoute> */}
      </ProtectedRoute>
    ),
  },
  {
    path: ROUTE_PATHS.USERS,
    element: (
      <ProtectedRoute>
        {/* <ProtectedDataRepoRoute> */}
          <DefaultView>
            <Users />
          </DefaultView>
        {/* </ProtectedDataRepoRoute> */}
      </ProtectedRoute>
    ),
  },
  {
    path: ROUTE_PATHS.FEEDBACK,
    element: (
      <ProtectedRoute>
          <DefaultView>
            <Feedback />
          </DefaultView>
        </ProtectedRoute>
    ),
  },
  { path: ROUTE_PATHS.DEFAULT, element: <Login /> },
  {
    path: '*',
    element: <Navigate to={ROUTE_PATHS.DEFAULT} />,
  },
];

export default routes;
